// components/ReportCardGenerator.jsx
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Button, CircularProgress, Alert, Typography } from '@mui/material';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { PDFTemplate } from '../utils/pdfGenerator';

const ReportCardGenerator = () => {
  const { studentId } = useParams();
  const [template, setTemplate] = useState(null);
  const [studentData, setStudentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Fetch default template
        const templateRes = await fetch('/api/templates/default');
        const templateData = await templateRes.json();
        setTemplate(templateData);
        
        // Fetch student data
        const studentRes = await fetch(`/api/students/${studentId}/report-data`);
        const studentData = await studentRes.json();
        setStudentData(studentData);
        
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [studentId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        {error}
      </Alert>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Report Card for {studentData?.student?.fullName || 'Student'}
      </Typography>
      
      <Box sx={{ mb: 3 }}>
        <PDFDownloadLink
          document={<PDFTemplate template={template} data={studentData} />}
          fileName={`report-card-${studentId}.pdf`}
        >
          {({ loading }) => (
            <Button variant="contained" disabled={loading}>
              {loading ? 'Preparing document...' : 'Download PDF'}
            </Button>
          )}
        </PDFDownloadLink>
      </Box>
      
      <Box sx={{ height: '80vh', border: '1px solid #ccc' }}>
        <PDFViewer width="100%" height="100%">
          <PDFTemplate template={template} data={studentData} />
        </PDFViewer>
      </Box>
    </Box>
  );
};

export default ReportCardGenerator;